import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../../_metronic/layout/core';
import { View } from './components/View';

const breadCrumbs: Array<PageLink> = [
  {
    title: 'Catálogos',
    path: '/catalogos/prueba',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];

const TestPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Prueba</PageTitle>
      <View />
    </>
  );
};

export { TestPage };
